export default __webpack_public_path__ + "static/media/041-scoop.28964aa0.svg";